<script setup lang="ts">
import Header from '@/layouts/main/header/Header.vue';
import Footer from '@/layouts/main/footer/Footer.vue';
import Dialog from '@/pages/page/components/Dialog.vue';
</script>

<template>
    <div class="layout">
        <div class="main-background"/>

        <div class="relative">
            <Header class="absolute inset-x-8 top-8 z-20 md:inset-x-20 md:top-15"/>

            <main class="min-h-screen">
                <RouterView/>

                <Dialog/>
            </main>
        </div>

        <Footer class="relative"/>
    </div>
</template>

<style scoped>

</style>
